import React, { useEffect, useState } from 'react';
import styled from 'styled-components/native';
import biometrics from '../../biometrics/biometrics';
import { Platform } from 'react-native';
import CustomToggleSwitch from '../../components/CustomToggleSwitch';
import Spacer from '../../components/Spacer';

const StyledScrollView = styled.ScrollView`
  background-color: #fdfbf7;
  padding: 32px 23px 32px 23px;
  flex: 1;
`;

const StyledContainer = styled.View`
  flex: 1;
  width: 100%;
  align-self: center;
  max-width: 768px;
  margin-top: ${Platform.OS === 'web' ? 0 : 10}px;
`;

const StyledSubtitle = styled.Text`
  font-family: 'DMSans-Medium';
  font-size: 16px;
  line-height: 18px;
  color: #141027;
`;

const StyledSettingsContainer = styled.View`
  flex-direction: row;
  min-width: 200px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const StyledLabel = styled.Text`
  font-family: 'DMSans-Bold';
  font-size: 18px;
  line-height: 23px;
  color: #232f55;
`;

const StyledCustomSwitch = styled(CustomToggleSwitch)``;

const MyProfileBiometricSettingsScreen: React.FC = () => {
  const [biometricLoginEnabled, setBiometricLoginEnabled] = useState(false);
  const getBiometricLoginStatus = async () => {
    const enabled = await biometrics.getBiometricLogin();
    setBiometricLoginEnabled(enabled === 'true');
  };
  useEffect(() => {
    if (Platform.OS !== 'web') {
      getBiometricLoginStatus();
    }
  }, []);
  return (
    <StyledScrollView contentContainerStyle={{ flexGrow: 1 }}>
      <StyledContainer>
        <StyledSubtitle>
          To enable{' '}
          {Platform.OS === 'ios'
            ? 'Face / Touch ID'
            : 'Face / Fingerprint Biometric'}{' '}
          go to your phone settings and enable the CHLOE app.
        </StyledSubtitle>
        <Spacer size={4} />
        <StyledSettingsContainer>
          <StyledLabel>
            {Platform.OS === 'ios'
              ? 'Face / Touch ID'
              : 'Face / Fingerprint Biometric'}
          </StyledLabel>
          <StyledCustomSwitch
            value={biometricLoginEnabled}
            onToggle={() => {
              biometrics.setBiometricLogin(!biometricLoginEnabled);
              setBiometricLoginEnabled(previousState => !previousState);
            }}
          />
        </StyledSettingsContainer>
      </StyledContainer>
    </StyledScrollView>
  );
};

export default MyProfileBiometricSettingsScreen;
